import { createFileRoute } from '@tanstack/react-router';
import { EntityManagementPage } from '../../../features/entity-management/components';

export const Route = createFileRoute('/_auth/entity-management/')({
  staticData: {
    title: 'pages.entityManagement.title',
    description: 'pages.entityManagement.description',
  },
  component: EntityManagementIndex,
});

function EntityManagementIndex() {
  return <EntityManagementPage />;
}
